module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_8023.8411b219.png";